export function isDefined<T>(x: T | null | undefined): x is T {
    return x !== null && x !== undefined;
}

export function assert(b: boolean, reason?: string) {
    if (!b) {
        const error = new Error('False assertion');
        console.error('[🚫 Assert] False assertion', reason, error.stack);
        throw error;
    }
}
